import * as THREE from 'three';
import nipplejs from 'nipplejs';
import { TerrainGenerator } from './terrain.js';
import { Player } from './player.js';
import { InputController } from './input.js';

class Game {
    constructor() {
        this.initialize();
    }

    initialize() {
        // Create renderer
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setClearColor(0x87CEEB); // Sky blue
        this.renderer.shadowMap.enabled = true;
        document.body.appendChild(this.renderer.domElement);

        // Create scene
        this.scene = new THREE.Scene();
        this.scene.fog = new THREE.FogExp2(0xFFFFFF, 0.0025);

        // Create camera
        this.camera = new THREE.PerspectiveCamera(
            75, window.innerWidth / window.innerHeight, 0.1, 1000
        );
        
        // Create lights
        const ambientLight = new THREE.AmbientLight(0xCCCCCC, 0.4);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 0.8);
        directionalLight.position.set(1, 1, 0.5).normalize();
        directionalLight.castShadow = true;
        directionalLight.shadow.mapSize.width = 2048;
        directionalLight.shadow.mapSize.height = 2048;
        directionalLight.shadow.camera.near = 0.5;
        directionalLight.shadow.camera.far = 500;
        this.scene.add(directionalLight);

        // Initialize terrain
        this.terrain = new TerrainGenerator(this.scene);
        
        // Initialize player
        this.player = new Player(this.scene, this.camera);
        
        // Initialize input controller
        this.inputController = new InputController();
        
        // Set up event listeners
        window.addEventListener('resize', () => this.onWindowResize());
        
        // Start game loop
        this.lastTime = 0;
        this.animate();
    }

    onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    update(deltaTime) {
        // Update player movement based on input
        this.player.update(deltaTime, this.inputController);
        
        // Update terrain around player
        this.terrain.update(this.player.getPosition());
    }

    animate(currentTime = 0) {
        requestAnimationFrame((time) => this.animate(time));
        
        const deltaTime = (currentTime - this.lastTime) / 1000;
        this.lastTime = currentTime;
        
        // Only update if delta time is valid
        if (deltaTime > 0 && deltaTime < 0.2) {
            this.update(deltaTime);
        }
        
        this.renderer.render(this.scene, this.camera);
    }
}

// Start the game when the window loads
window.addEventListener('load', () => {
    new Game();
}); 